import CCColors from '@/Utils/CCColors';
import React, {useEffect, useState} from 'react';
import {View, Image, Linking, StyleSheet} from 'react-native';
import Box from '../Box';
import CCText from '../CCText';
import CCCheckbox from '../CCCheckbox';
import {FontSizes} from '@/Utils/Dimensions';
import CCButton from '../CCButton';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';

const SwitchToAppModal = ({setShowAppModalHome, isMobileOrTab}) => {
  const [appDownloaded, setAppDownloaded] = useState(false);
  const [platformOS, setPlatformOS] = useState<
    'iOS' | 'Android' | 'Other' | null
  >(null);
  // Add this line
  const getMobileOS = (): 'iOS' | 'Android' | 'Other' => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      // Optional: guard against MS Stream (rare legacy IE scenario)
      const isNotWindows = !(
        typeof window !== 'undefined' && 'MSStream' in window
      );
      if (isNotWindows) {
        return 'iOS';
      }
    }

    return 'Other';
  };
  console.log(platformOS, 'platformOS');

  useEffect(() => {
    setPlatformOS(getMobileOS());
  }, []);
  return (
    <View
      style={[
        styles.wrapper,
        {
          alignItems: !isMobileOrTab ? 'flex-end' : 'center',
          // force on top
          paddingRight: isMobileOrTab ? 0 : 10,
          paddingBottom: isMobileOrTab ? 0 : 20,
        },
      ]}>
      <Box
        onPress={() => {
          setShowAppModalHome(false);
        }}
        style={[
          styles.subwrapper,
          {
            bottom: isMobileOrTab ? '61%' : '54%',
          },
        ]}>
        <MaterialCommunityIcons
          name="close"
          size={24}
          color={CCColors.Primary.Dark}
        />
      </Box>
      <View
        style={[
          styles.part1,
          {
            width: isMobileOrTab ? '100%' : '26%',
            height: isMobileOrTab ? '60%' : '52%',
            borderBottomRightRadius: isMobileOrTab ? 0 : 10,
            borderBottomLeftRadius: isMobileOrTab ? 0 : 10,
          },
        ]}>
        <View style={{flex: 1, width: '100%'}}>
          <View
            style={{
              backgroundColor: CCColors.Primary.Dark,
              height: !isMobileOrTab ? '50%' : '55%',
            }}>
            <Image
              source={require('@/Assets/Images/Svgs/appModalImage.jpg')}
              style={{
                width: '100%',
                height: '100%',
                resizeMode: 'cover',
              }}
            />
          </View>
          <View style={styles.header}>
            <CCText
              fontSize={isMobileOrTab ? FontSizes[18] : FontSizes[16]}
              fontWeight="bold">
              Get the Best Experience on our App
            </CCText>
            <CCText
              style={{
                paddingTop: '4%',
              }}
              fontSize={isMobileOrTab ? FontSizes[16] : FontSizes[14]}
              color={CCColors.TextColor.GreyText}>
              Enjoy a faster, smoother play experience and stay updated with the
              latest tournaments, coaching offers, and more — all in one place.
            </CCText>
            {/* <Box
              style={{
                paddingVertical: 15,
              }}>
              <CCCheckbox
                label={'I’ve downloaded the app'}
                value={appDownloaded}
                onValueChange={() => setAppDownloaded(!appDownloaded)}
                customStyle={{
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onLabelPress={() => setAppDownloaded(!appDownloaded)}
                customFont={FontSizes[12]}
                fontColor={CCColors.TextColor.GreyText}
              />
            </Box> */}
            <Box
              flex={1}
              flexDirection="row"
              justifyContent={'center'}
              style={[{gap: isMobileOrTab ? 20 : 0}, styles.box]}>
              {platformOS === 'iOS' && (
                <Box flex={1}>
                  <CCButton
                    onPress={() =>
                      Linking.openURL(
                        'https://apps.apple.com/in/app/circlechess-live-tournaments/id6743388978',
                      )
                    }
                    contentContainerStyle={{
                      // paddingHorizontal: isMobileOrTab ? 36 : 16,
                      paddingVertical: 8,
                    }}
                    style={styles.icon}>
                    <MaterialCommunityIcons
                      name="apple"
                      size={20}
                      color={CCColors.Black}
                    />
                    <CCText
                      style={{
                        paddingLeft: 5,
                      }}
                      fontSize={isMobileOrTab ? FontSizes[16] : FontSizes[14]}
                      fontWeight="bold">
                      App Store
                    </CCText>
                  </CCButton>
                </Box>
              )}
              {platformOS === 'Android' && (
                <Box flex={1}>
                  {' '}
                  <CCButton
                    onPress={() =>
                      Linking.openURL(
                        'https://play.google.com/store/apps/details?id=com.circlechess.cc_learning',
                      )
                    }
                    contentContainerStyle={{
                      // paddingHorizontal: isMobileOrTab ? 36 : 56,
                      paddingVertical: 8,
                    }}
                    style={styles.image}>
                    <Image
                      source={require('@/Assets/Images/Svgs/playstore.svg')}
                      style={{width: 17, height: 17}}
                    />
                    <CCText
                      style={[
                        styles.button,
                        {paddingVertical: isMobileOrTab ? 1.5 : 0},
                      ]}
                      fontSize={isMobileOrTab ? FontSizes[16] : FontSizes[14]}
                      fontWeight="bold">
                      Play Store
                    </CCText>
                  </CCButton>
                </Box>
              )}
              {platformOS === 'Other' && (
                <Box
                  flexDirection="row"
                  justifyContent="center"
                  gap={'8%'}
                  flex={1}>
                  <Box
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      width: '40%',
                    }}>
                    <CCButton
                      onPress={() =>
                        Linking.openURL(
                          'https://apps.apple.com/in/app/circlechess-live-tournaments/id6743388978',
                        )
                      }
                      contentContainerStyle={[
                        styles.apple,
                        {paddingHorizontal: isMobileOrTab ? 36 : 16},
                      ]}
                      style={{flexDirection: 'row', gap: 30, width: '100%'}}>
                      <MaterialCommunityIcons
                        name="apple"
                        size={20}
                        color={CCColors.Black}
                      />
                      <CCText
                        style={{
                          paddingLeft: 5,
                        }}
                        fontSize={isMobileOrTab ? FontSizes[16] : FontSizes[14]}
                        fontWeight="bold">
                        App Store
                      </CCText>
                    </CCButton>
                  </Box>
                  <Box
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      width: '40%',
                    }}>
                    <CCButton
                      onPress={() =>
                        Linking.openURL(
                          'https://play.google.com/store/apps/details?id=com.circlechess.cc_learning',
                        )
                      }
                      contentContainerStyle={[
                        styles.apple,
                        {
                          paddingHorizontal: isMobileOrTab ? 36 : 16,
                        },
                      ]}
                      style={{flexDirection: 'row', gap: 30, width: '100%'}}>
                      <Image
                        source={require('@/Assets/Images/Svgs/playstore.svg')}
                        style={{width: 17, height: 17}}
                      />
                      <CCText
                        style={[
                          styles.button,
                          {
                            paddingVertical: isMobileOrTab ? 1.5 : 0,
                          },
                        ]}
                        fontSize={isMobileOrTab ? FontSizes[16] : FontSizes[14]}
                        fontWeight="bold">
                        Play Store
                      </CCText>
                    </CCButton>
                  </Box>
                </Box>
              )}
            </Box>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'flex-end',
    zIndex: 9999,
  },
  subwrapper: {
    position: 'absolute',
    right: 8,
    backgroundColor: CCColors.CCTableBg,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
    zIndex: 10000,
    elevation: 5,
    padding: 2,
  },
  part1: {
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    alignItems: 'center',
    backgroundColor: CCColors.White,
    position: 'relative',
    overflow: 'hidden',
  },
  header: {
    flex: 1,
    backgroundColor: CCColors.White,
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '4%',
  },
  icon: {
    flexDirection: 'row',
    gap: 30,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    flexDirection: 'row',
    gap: 30,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    paddingLeft: 5,
  },
  apple: {
    paddingVertical: 8,
  },
  box: {
    width: '100%',

    paddingTop: '4%',
  },
});

export default SwitchToAppModal;
